import React from "react";
import Typography from "@mui/material/Typography";
import { ErrorMessage } from "formik";
import Div from "@jumbo/shared/Div/Div";
import JumboAppTextField from "@jumbo/components/JumboAppTextField/JumboAppTextField";
import { outerDiv } from "app/utils/constants/dropdowns";

const FormTextField1 = ({
  label,
  name,
  type,
  onChange,
  error,
  status,
  helperText,
  value,
  accept,
  sx,
  rows,
}) => {
  return (
    <Div
      sx={{
        display: "flex",
        width: "100%",
        flexDirection: "column",
      }}
    >
      <Typography variant="h5">{label ? `${label}*` : ``}</Typography>
      {type === "file" ? (
        <input
        multiline
        rows={rows}
          type="file"
          id={name}
          name={name}
          accept={accept}
          onChange={onChange}
          sx={{
            width: "100%",
            fontSize: "1rem",
          }}
        />
      ) : (
        <JumboAppTextField
          multiline
          rows={rows}
          type={type}
          disabled={status}
          id={name}
          name={name}
          onChange={onChange}
          // initialValue={value}
          // variant="standard"
          sx={{
            width: "100%",
            ".css-17vd7jc-MuiInputBase-root-MuiOutlinedInput-root": {
              padding: 1,
              fontSize: "1rem",
            },

            ...sx,
          }}
        />
      )}
      <Div sx={{ height: "30px", mt: 0.5 }}>
        <ErrorMessage name={name} component="div" style={{ color: "red" }} />
        {error && <div style={{ color: "red" }}>{helperText}</div>}
      </Div>
    </Div>
  );
};

export default FormTextField1;
